import keyMirror from "key-mirror";

export const INITIATE_CASE_STATE = "INITIATE_CASE_STATE";

export const USER_ACTIONS = keyMirror({
    FETCH_USER: null,
    FETCHED_USER: null,
    FAILED_FETCH_USER: null,
    FETCH_USER_PERMISSIONS: null,
    FETCHED_USER_PERMISSIONS: null,
    FAILED_FETCH_USER_PERMISSIONS: null
});

export const AUTH_ACTIONS = keyMirror({
    AUTHENTICATE: null,
    AUTHENTICATED: null,
    FAILED_AUTHENTICATE: null,
    LOGOUT: null
});

export const CASE_ACTIONS = keyMirror({
    FETCH_CASES_COUNT: null,
    FETCHED_CASES_COUNT: null,
    FAILED_FETCH_CASES_COUNT: null,
    FETCH_CASES: null,
    FETCHED_CASES: null,
    FAILED_FETCH_CASES: null,
    FETCH_MORE_CASES: null,
    FETCHED_MORE_CASES: null,
    FAILED_FETCH_MORE_CASES: null,
    UPGRADE_CASES: null,
    UPGRADED_CASES: null,
    FAILED_UPGRADE_CASES: null,
    DOWNLOAD_CASES_XLSX: null
});

export const CASE_DETAILS_ACTIONS = keyMirror({
    FETCH_CASE_DETAILS: null,
    FETCHED_CASE_DETAILS: null,
    FAILED_FETCH_CASE_DETAILS: null,
    FETCH_CASE_ASSOCIATES: null,
    FETCHED_CASE_ASSOCIATES: null,
    FAILED_FETCH_CASE_ASSOCIATES: null,
    ADD_CASE_ASSOCIATES: null,
    ADDED_CASE_ASSOCIATES: null,
    FAILED_ADD_CASE_ASSOCIATES: null,
    DELETE_CASE_ASSOCIATES: null,
    DELETED_CASE_ASSOCIATES: null,
    FAILED_DELETE_CASE_ASSOCIATES: null,
    UPDATE_CASE_DETAILS: null,
    UPDATED_CASE_DETAILS: null,
    FAILED_UPDATE_CASE_DETAILS: null,
    FETCH_CASE_SUPPLY_DETAILS: null,
    FETCHED_CASE_SUPPLY_DETAILS: null,
    FAILED_FETCH_CASE_SUPPLY_DETAILS: null,
    UPDATED_CASE_DETAILS_SALES: null,
    FETCH_CHANNEL_PRODUCT_STATS: null,
    FETCHED_CHANNEL_PRODUCT_STATS: null,
    FAILED_FETCH_CHANNEL_PRODUCT_STATS: null,
    UPDATE_CHANNEL_PRODUCT_STATS: null,
    UPDATED_CHANNEL_PRODUCT_STATS: null,
    FAILED_UPDATE_CHANNEL_PRODUCT_STATS: null,
    UPDATE_CASE_REMARKS: null,
    UPDATED_CASE_REMARKS: null,
    FAILED_UPDATE_CASE_REMARKS: null,
    DOWNLOAD_APPLICATION_FORM: null,
    DOWNLOADED_APPLICATION_FORM: null,
    FAILED_DOWNLOAD_APPLICATION_FORM: null,
    UPDATE_COMPANY_LEDGERS: null,
    UPDATED_COMPANY_LEDGERS: null,
    FAILED_UPDATE_COMPANY_LEDGERS: null,
    ADD_NEW_PRODUCT: null,
    UPDATE_CASE_QUESTIONNAIRE: null,
    UPDATED_CASE_QUESTIONNAIRE: null,
    FAILED_UPDATE_CASE_QUESTIONNAIRE: null,
    DOWNLOAD_CASE_QUESTIONNAIRE: null,
    UPDATE_CASE_TYPE: null,
    UPDATED_CASE_TYPE: null,
    FAILED_UPDATE_CASE_TYPE: null,
    MOVE_CASE_TO_LMS: null,
    FETCH_CASE_BANK_ACCOUNTS: null,
    FETCHED_CASE_BANK_ACCOUNTS: null,
    FAILED_FETCH_CASE_BANK_ACCOUNTS: null,
    ADD_CASE_BANK_ACCOUNTS: null,
    ADDED_CASE_BANK_ACCOUNTS: null,
    FAILED_ADD_CASE_BANK_ACCOUNTS: null,
    DELETE_CASE_BANK_ACCOUNTS: null,
    DELETED_CASE_BANK_ACCOUNTS: null,
    FAILED_DELETE_CASE_BANK_ACCOUNTS: null,
    FETCH_CASE_CHECKLIST: null,
    FETCHED_CASE_CHECKLIST: null,
    FAILED_FETCH_CASE_CHECKLIST: null,
    FETCH_GSTIN_SEARCH: null,
    UPDATE_DELETE_ASSOCIATE_STATUS: null,
    ADD_CASE_COMPANY_ASSOCIATES: null,
    FETCH_CASE_REMARKS: null,
    FETCHED_CASE_REMARKS: null,
    FAILED_FETCH_CASE_REMARKS: null,
    FETCH_CASE_NACH_MANDATE_DETAILS: null,
    FETCHED_CASE_NACH_MANDATE_DETAILS: null,
    FETCH_FAILED_CASE_NACH_MANDATE_DETAILS: null,
    FETCH_CASE_ENACH_MANDATE_STATUS: null,
    FETCHED_CASE_ENACH_MANDATE_STATUS: null,
    FETCH_FAILED_CASE_ENACH_MANDATE_STATUS: null,

});

export const CASE_NOTE_ACTIONS = keyMirror({
    FETCH_CASE_NOTES: null,
    FETCHED_CASE_NOTES: null,
    FAILED_FETCH_CASE_NOTES: null,
    CREATE_CASE_NOTE: null,
    CREATED_CASE_NOTE: null,
    FAILED_CREATE_CASE_NOTE: null,
    DELETE_CASE_NOTE: null,
    DELETED_CASE_NOTE: null,
    FAILED_DELETE_CASE_NOTE: null,
    RETRIEVE_CASE_NOTE: null,
    RETRIEVED_CASE_NOTE: null,
    FAILED_RETRIEVE_CASE_NOTE: null
});

export const PAYPRO_CASE_NOTE_ACTIONS = keyMirror({
    FETCH_PAYPRO_CASE_NOTES: null,
    FETCHED_PAYPRO_CASE_NOTES: null,
    FAILED_FETCH_PAYPRO_CASE_NOTES: null,
});

export const COMPANY_ACTIONS = keyMirror({
    FETCH_COMPANY_PROFILE: null,
    FETCHED_COMPANY_PROFILE: null,
    FAILED_FETCH_COMPANY_PROFILE: null,

    UPDATE_COMPANY_PROFILE: null,
    UPDATED_COMPANY_PROFILE: null,
    FAILED_UPDATE_COMPANY_PROFILE: null,

    UPDATE_COMPANY_ASSOCIATES: null,
    UPDATED_COMPANY_ASSOCIATES: null,
    FAILED_UPDATE_COMPANY_ASSOCIATES: null,

    FETCH_COMPANY_ASSOCIATES: null,
    FETCHED_COMPANY_ASSOCIATES: null,
    FAILED_FETCH_COMPANY_ASSOCIATES: null,

    FETCH_COMPANY_ADDRESSES: null,
    FETCHED_COMPANY_ADDRESSES: null,
    FAILED_FETCH_COMPANY_ADDRESSES: null,

    UPDATE_COMPANY_ADDRESSES: null,
    UPDATED_COMPANY_ADDRESSES: null,
    FAILED_UPDATE_COMPANY_ADDRESSES: null,

    UPDATE_COMPANY_ADDRESS: null,
    UPDATED_COMPANY_ADDRESS: null,
    FAILED_UPDATE_COMPANY_ADDRESS: null,

    FETCH_COMPANY_BANK_ACCOUNTS: null,
    FETCHED_COMPANY_BANK_ACCOUNTS: null,
    FAILED_FETCH_COMPANY_BANK_ACCOUNTS: null,

    UPDATE_COMPANY_BANK_ACCOUNTS: null,
    UPDATED_COMPANY_BANK_ACCOUNTS: null,
    FAILED_UPDATE_COMPANY_BANK_ACCOUNTS: null,

    UPDATE_COMPANY_ASSOCIATES_CIBIL: null,
    UPDATED_COMPANY_ASSOCIATES_CIBIL: null,
    FAILED_UPDATE_COMPANY_ASSOCIATES_CIBIL: null,

    FETCH_COMPANY_LOS_PROFILE_LIST: null,
    FETCHED_COMPANY_LOS_PROFILE_LIST: null,
    FAILED_FETCH_COMPANY_LOS_PROFILE_LIST: null,

    CREATE_COMPANY_LOS_PROFILE: null,
    CREATED_COMPANY_LOS_PROFILE: null,
    FAILED_CREATE_COMPANY_LOS_PROFILE: null,

    FETCH_COMPANY_LOS_PROFILE: null,
    FETCHED_COMPANY_LOS_PROFILE: null,
    FAILED_FETCH_COMPANY_LOS_PROFILE: null,

    FETCH_COMPANY_LOS_DETAILS: null,
    FETCHED_COMPANY_LOS_DETAILS: null,
    FAILED_FETCH_COMPANY_LOS_DETAILS: null,

    FETCH_COMPANY_LOS_ATTACHMENTS: null,
    FETCHED_COMPANY_LOS_ATTACHMENTS: null,
    FAILED_FETCH_COMPANY_LOS_ATTACHMENTS: null,

    UPDATE_COMPANY_SINGLE_ASSOCIATE: null,
    UPDATED_COMPANY_SINGLE_ASSOCIATE: null,
    FAILED_UPDATE_COMPANY_SINGLE_ASSOCIATE: null,

    UPDATE_COMPANY_MULTIPLE_ASSOCIATE: null,
    UPDATED_COMPANY_MULTIPLE_ASSOCIATE: null,
    FAILED_UPDATE_COMPANY_MULTIPLE_ASSOCIATE: null,

    UPDATE_COMPANY_SINGLE_BANK_ACCOUNT: null,
    UPDATED_COMPANY_SINGLE_BANK_ACCOUNT: null,
    FAILED_UPDATE_COMPANY_SINGLE_BANK_ACCOUNT: null,

    UPDATE_COMPANY_SINGLE_ADDRESS: null,
    UPDATED_COMPANY_SINGLE_ADDRESS: null,
    FAILED_UPDATE_COMPANY_SINGLE_ADDRESS: null,

    FETCH_COMPANY_GSTIN_FILLING_DETAILS: null,
    FETCHED_COMPANY_GSTIN_FILLING_DETAILS: null,
    FAILED_FETCH_COMPANY_GSTIN_FILLING_DETAILS: null,

    REFRESH_COMPANY_GSTIN_FILLING_DETAILS: null,
    REFRESHED_COMPANY_GSTIN_FILLING_DETAILS: null,
    FAILED_REFRESH_COMPANY_GSTIN_FILLING_DETAILS: null,

    FETCH_COMPANY_CHECKLIST: null,
    FETCHED_COMPANY_CHECKLIST: null,
    FAILED_FETCH_COMPANY_CHECKLIST: null,

    FETCH_COMPANY_NOTES: null,
    FETCHED_COMPANY_NOTES: null,
    FAILED_FETCH_COMPANY_NOTES: null,

    CREATE_COMPANY_NOTE: null,
    FETCHED_CREATE_COMPANY_NOTE: null,
    FAILED_CREATE_COMPANY_NOTE: null,

    FETCH_COMPANY_ASSOCIATES_V2: null,
    FETCHED_COMPANY_ASSOCIATES_V2: null,
    FAILED_FETCH_COMPANY_ASSOCIATES_V2: null,

    UPDATE_MPA_DETAILS: null,
    UPDATED_MPA_DETAILS: null,
    FAILED_UPDATE_MPA_DETAILS: null,

    FETCH_COMPANY_ALL_MPA: null,
    FETCHED_COMPANY_ALL_MPA: null,
    FAILED_FETCH_COMPANY_ALL_MPA: null,
    CLEAR_COMPANY_ALL_MPA: null,

    FETCH_COMPANY_PROFILE: null,
    FETCHED_COMPANY_PROFILE: null,
    FAILED_FETCH_COMPANY_PROFILE: null,

    FETCH_ENUMS: null,
    FETCHED_ENUMS: null,
    FAILED_FETCH_ENUMS: null,

    FETCH_PAN_AADHAR_LINK: null,
    FETCHED_PAN_AADHAR_LINK: null,
    FAILED_FETCH_PAN_AADHAR_LINK: null,


});

export const ACCOUNT_VIEW_ACTIONS = keyMirror({
    FETCH_ACCOUNT_SUMMARY: null,
    FETCHED_ACCOUNT_SUMMARY: null,
    FAILED_FETCH_ACCOUNT_SUMMARY: null,

    FETCH_ACCOUNT_STATEMENT: null,
    FETCHED_ACCOUNT_STATEMENT: null,
    FAILED_FETCH_ACCOUNT_STATEMENT: null,

    FETCH_FACILITY_ACCOUNT_OPEN_INVOICES: null,
    FETCHED_FACILITY_ACCOUNT_OPEN_INVOICES: null,
    FAILED_FETCH_FACILITY_ACCOUNT_OPEN_INVOICES: null,
});

export const FINANCIALS_ACTIONS = keyMirror({
    FETCH_FINANCIALS: null,
    FETCHED_FINANCIALS: null,
    FAILED_FETCH_FINANCIALS: null,

    UPDATE_FINANCIALS: null,
    UPDATED_FINANCIALS: null,
    FAILED_UPDATE_FINANCIALS: null,

    FETCH_FINANCIAL_YEARS: null,
    FETCHED_FINANCIAL_YEARS: null,
    FAILED_FETCH_FINANCIAL_YEARS: null,

    CREATE_FINANCIAL_YEAR: null,
    CREATED_FINANCIAL_YEAR: null,
    FAILED_CREATE_FINANCIAL_YEAR: null
});

export const STAGE_ACTIONS = keyMirror({
    FETCH_STAGES_LIST: null,
    FETCHED_STAGES_LIST: null,
    FAILED_FETCH_STAGES_LIST: null
});

export const STAGE_CASE_ACTIONS = keyMirror({
    FETCH_STAGE_CASE: null,
    FETCHED_STAGE_CASE: null,
    FAILED_STAGE_CASE: null,
    FETCHED_STAGE_CASE_COUNT: null,
    RESET_STAGE_CASE: null,
    RESET_INBOX_STAGE: null
});

export const QUESTIONARE_ACTIONS = keyMirror({
    FETCH_QUESTIONARE: null,
    FETCHED_QUESTIONARE: null,
    FAILED_FETCH_QUESTIONARE: null,
    FETCH_ANSWERS_FOR_QUESTIONARE: null,
    FETCHED_ANSWERS_FOR_QUESTIONARE: null,
    FAILED_FETCH_ANSWERS_FOR_QUESTIONARE: null,
    UPDATE_QUESTIONARE_ANSWER: null,
    UPDATED_QUESTIONARE_ANSWER: null,
    FAILED_UPDATE_QUESTIONARE_ANSWER: null,
    DOWNLOAD_CASE_QUESTIONNAIRE: null,
});

export const RETAILER_RISK_CONTROL_ACTIONS = keyMirror({
    FETCH_RETAILER_RISK_CONTROL_DETAIL: null,
    FETCHED_RETAILER_RISK_CONTROL_DETAIL: null,
    FAILED_FETCH_RETAILER_RISK_CONTROL_DETAIL: null,
    UPDATE_RETAILER_RISK_CONTROL_DETAIL: null,
    UPDATED_RETAILER_RISK_CONTROL_DETAIL: null,
    FAILED_UPDATE_RETAILER_RISK_CONTROL_DETAIL: null,
});

export const UPDATE_STAGE_CASE = keyMirror({
    PROCEED_CASE: null,
    SUCCESS_PROCEED_CASE: null,
    FAILED_PROCEED_CASE: null,
    REJECT_CASE: null,
    SUCCESS_REJECT_CASE: null,
    FAILED_REJECT_CASE: null,
    HOLD_CASE: null,
    SUCCESS_HOLD_CASE: null,
    FAILED_HOLD_CASE: null,
    OPEN_CASE: null,
    SUCCESS_OPEN_CASE: null,
    FAILED_OPEN_CASE: null,
    REFER_CASE: null,
    SUCCESS_REFER_CASE: null,
    FAILED_REFER_CASE: null,
    APPROVE_CASE: null,
    SUCCESS_APPROVE_CASE: null,
    FAILED_APPROVE_CASE: null,
    APPROVE_CASE_BULK: null,
    REJECT_CASE_BULK: null,
    PROCEED_BULK_CASES: null,
    REFER_BULK_CASES: null,
    REJECT_BULK_CASES: null,
    APPROVE_BULK_CASES: null,
    ASSIGN_CASE: null,
    SUCCESS_ASSIGN_CASE: null,
    FAILED_ASSIGN_CASE: null,
    REASSIGN_CASE: null,
    SUCCESS_REASSIGN_CASE: null,
    FAILED_REASSIGN_CASE: null,
});

export const SUPPLY_CHAIN_ACTIONS = keyMirror({
    FETCH_CASE_SUPPLY_CHAIN_DETAILS: null,
    FETCHED_CASE_SUPPLY_CHAIN_DETAILS: null,
    FAILED_FETCH_CASE_SUPPLY_CHAIN_DETAILS: null,
    UPDATE_CASE_SUPPLY_CHAIN_DETAILS: null,
    UPDATED_CASE_SUPPLY_CHAIN_DETAILS: null,
    FAILED_UPDATE_CASE_SUPPLY_CHAIN_DETAILS: null,
    //Financials Data Related Actions
    FETCH_CASE_SUPPLY_CHAIN_FINANCIALS: null,
    FETCHED_CASE_SUPPLY_CHAIN_FINANCIALS: null,
    FAILED_FETCH_CASE_SUPPLY_CHAIN_FINANCIALS: null
});

export const RESET_STORE = "RESET_STORE";

export const DOCUMENTS_ACTIONS = keyMirror({
    FETCH_DOCUMENTS_CHECKLIST: null,
    FETCHED_DOCUMENTS_CHECKLIST: null,
    FAILED_FETCH_DOCUMENTS_CHECKLIST: null,

    FETCH_CASE_DOCUMENTS: null,
    FETCHED_CASE_DOCUMENTS: null,
    FAILED_FETCH_CASE_DOCUMENTS: null,

    FETCH_COMPANY_DOCUMENTS: null,
    FETCHED_COMPANY_DOCUMENTS: null,
    FAILED_FETCH_COMPANY_DOCUMENTS: null,

    FETCH_DOCUMENTS_CASE_V2: null,
    FETCHED_DOCUMENTS_CASE_V2: null,
    FAILED_FETCH_DOCUMENTS_CASE_V2: null,

    
    ATTACH_DOCUMENTS: null,
    ATTACHED_DOCUMENTS: null,
    FAILED_ATTACH_DOCUMENTS: null,

    UPLOAD_DOCUMENT: null,
    UPLOADED_DOCUMENT: null,
    FAILED_UPLOAD_DOCUMENT: null,

    UPLOAD_DOCUMENTS: null,
    UPLOADED_DOCUMENTS: null,
    FAILED_UPLOAD_DOCUMENTS: null,

    UPDATE_DOCUMENTS: null,
    UPDATED_DOCUMENTS: null,
    FAILED_UPDATE_DOCUMENTS: null,

    VALIDATE_DOCUMENT: null,
    VALIDATED_DOCUMENT: null,
    VALIDATED_DOCUMENT_APPROVAL: null,
    FAILED_VALIDATE_DOCUMENT: null,

    INVALIDATE_DOCUMENT: null,
    INVALIDATED_DOCUMENT_STATUS: null,
    FAILED_INVALIDATE_DOCUMENT_STATUS: null,
    INVALIDATED_DOCUMENT: null,
    FAILED_INVALIDATE_DOCUMENT: null
});

export const STATEMENT_ACTIONS = keyMirror({
    CREATE_STATEMENT: null,
    CREATED_STATEMENT: null,
    FAILED_CREATE_STATEMENT: null,
    DELETE_STATEMENT: null,
    DELETED_STATEMENT: null,
    FAILED_DELETE_STATEMENT: null,

    FETCH_STATEMENT: null,
    FETCHED_STATEMENT: null,
    FAILED_FETCH_STATEMENT: null,

    UPDATE_STATEMENT: null,
    UPDATED_STATEMENT: null,
    FAILED_UPDATE_STATEMENT: null
});

export const SCORECARD_ACTIONS = keyMirror({
    FETCH_SCORECARD: null,
    FETCHED_SCORECARD: null,
    FAILED_FETCH_SCORECARD: null,

    GENERATE_SCORECARD: null,
    GENERATED_SCORECARD: null,
    FAILED_GENERATE_SCORECARD: null
});

export const CASE_CREATE_ACTIONS = keyMirror({
    ADD_CASE_ENTRY: null,
    REMOVE_CASE_ENTRY: null,
    OPEN_CASE: null,
    UPDATE_OPEN_CASE: null,
    SUCCESS_OPEN_CASE: null,
    FAILED_OPEN_CASE: null,
    CREATE_CASE: null,
    CREATED_CASE: null,
    FAILED_CREATE_CASE: null,
    RESET_CASE_CREATE: null,
    BULK_ADHOC_CASE_CREATE: null,
    BULK_ADHOC_CASE_CREATED: null,
    BULK_ADHOC_CASE_CREATE_FAILED: null,
    BULK_PAYPRO_CASE_CREATE: null,
    BULK_PAYPRO_CASE_CREATED: null,
    BULK_PAYPRO_CASE_CREATE_FAILED: null
});

export const CASE_META_ACTIONS = keyMirror({
    UPDATE_CASE_META: null,
    UPDATED_CASE_META: null,
    FAILED_UPDATE_CASE_META: null,
    RESET_CASE_META: null
});

export const BUCKET_LIST_ACTIONS = keyMirror({
    FETCH_CASE_BUCKET_LIST: null,
    FETCHED_CASE_BUCKET_LIST: null,
    FAILED_FETCH_BUCKET_LIST: null,
    ASSIGN_CASE_FROM_BUCKET: null,
    ASSIGNED_CASE_FROM_BUCKET: null,
    FAILED_ASSIGN_CASE_FROM_BUCKET: null,
    PROCEED_BUCKET_CASE: null,
    SUCCESS_PROCEED_BUCKET_CASE: null,
    FAILED_PROCEED_BUCKET_CASE: null,
    REFER_BUCKET_CASE: null,
    SUCCESS_REFER_BUCKET_CASE: null,
    FAILED_REFER_BUCKET_CASE: null,
    BULK_ASSIGN_CASE_FROM_BUCKET: null,
    BULK_ASSIGNED_CASE_FROM_BUCKET: null,
    FAILED_BULK_ASSIGN_CASE_FROM_BUCKET: null,
});

export const MPA_DPA_ACTIONS = keyMirror({
    FETCH_BUSINESS_PRODUCT_LIST: null,
    FETCHED_BUSINESS_PRODUCT_LIST: null,
    FAILED_FETCH_BUSINESS_PRODUCT_LIST: null,

    FETCH_BUSINESS_PROGRAM: null,
    FETCHED_BUSINESS_PROGRAM: null,
    FAILED_FETCH_BUSINESS_PROGRAM: null,

    FETCH_BUSINESS_PROGRAM_LIST: null,
    FETCHED_BUSINESS_PROGRAM_LIST: null,
    FAILED_FETCH_BUSINESS_PROGRAM_LIST: null,

    FETCH_BUSINESS_PROGRAM_DETAIL: null,
    FETCHED_BUSINESS_PROGRAM_DETAIL: null,
    FAILED_FETCH_BUSINESS_PROGRAM_DETAIL: null,

    FETCH_COMPANY_BUSINESS_PROGRAM_DETAIL: null,
    FETCHED_COMPANY_BUSINESS_PROGRAM_DETAIL: null,
    FAILED_FETCH_COMPANY_BUSINESS_PROGRAM_DETAIL: null,
    // CREATE ACTIONS
    CREATE_BUSINESS_PROGRAM_DETAIL: null,
    CREATED_BUSINESS_PROGRAM_DETAIL: null,
    FAILED_CREATE_BUSINESS_PROGRAM_DETAIL: null,

    CREATE_BUSINESS_PROGRAM_BASIC_DETAIL: null,
    CREATED_BUSINESS_PROGRAM_BASIC_DETAIL: null,
    FAILED_CREATE_BUSINESS_PROGRAM_BASIC_DETAIL: null,

    CREATE_BUSINESS_FACILITY_DETAIL: null,
    CREATED_BUSINESS_FACILITY_DETAIL: null,
    FAILED_CREATE_BUSINESS_FACILITY_DETAIL: null,

    CREATE_BUSINESS_QUALIFICATION_DETAIL: null,
    CREATED_BUSINESS_QUALIFICATION_DETAIL: null,
    FAILED_CREATE_BUSINESS_QUALIFICATION_DETAIL: null,

    CREATE_BUSINESS_FEE_DETAIL: null,
    CREATED_BUSINESS_FEE_DETAIL: null,
    FAILED_CREATE_BUSINESS_FEE_DETAIL: null,

    CREATE_BUSINESS_INTEREST_DETAIL: null,
    CREATED_BUSINESS_INTEREST_DETAIL: null,
    FAILED_CREATE_BUSINESS_INTEREST_DETAIL: null,

    CREATE_BUSINESS_RECOURSE_DETAIL: null,
    CREATED_BUSINESS_RECOURSE_DETAIL: null,
    FAILED_CREATE_BUSINESS_RECOURSE_DETAIL: null,

    CREATE_BUSINESS_CASHBACK_DETAIL: null,
    CREATED_BUSINESS_CASHBACK_DETAIL: null,
    FAILED_CREATE_BUSINESS_CASHBACK_DETAIL: null,

    CREATE_BUSINESS_AGREEMENT_DETAIL: null,
    CREATED_BUSINESS_AGREEMENT_DETAIL: null,
    FAILED_CREATE_BUSINESS_AGREEMENT_DETAIL: null,

    CREATE_BUSINESS_ATTACHMENT_DETAIL: null,
    CREATED_BUSINESS_ATTACHMENT_DETAIL: null,
    FAILED_CREATE_BUSINESS_ATTACHMENT_DETAIL: null,

    // UPDATE ACTIONS
    UPDATE_BUSINESS_PROGRAM_DETAIL: null,
    UPDATED_BUSINESS_PROGRAM_DETAIL: null,
    FAILED_UPDATE_BUSINESS_PROGRAM_DETAIL: null,

    UPDATE_BUSINESS_PROGRAM_BASIC_DETAIL: null,
    UPDATED_BUSINESS_PROGRAM_BASIC_DETAIL: null,
    FAILED_UPDATE_BUSINESS_PROGRAM_BASIC_DETAIL: null,

    UPDATE_BUSINESS_FACILITY_DETAIL: null,
    UPDATED_BUSINESS_FACILITY_DETAIL: null,
    FAILED_UPDATE_BUSINESS_FACILITY_DETAIL: null,

    UPDATE_BUSINESS_QUALIFICATION_DETAIL: null,
    UPDATED_BUSINESS_QUALIFICATION_DETAIL: null,
    FAILED_UPDATE_BUSINESS_QUALIFICATION_DETAIL: null,

    UPDATE_BUSINESS_FEE_DETAIL: null,
    UPDATED_BUSINESS_FEE_DETAIL: null,
    FAILED_UPDATE_BUSINESS_FEE_DETAIL: null,

    UPDATE_BUSINESS_INTEREST_DETAIL: null,
    UPDATED_BUSINESS_INTEREST_DETAIL: null,
    FAILED_UPDATE_BUSINESS_INTEREST_DETAIL: null,

    UPDATE_BUSINESS_RECOURSE_DETAIL: null,
    UPDATED_BUSINESS_RECOURSE_DETAIL: null,
    FAILED_UPDATE_BUSINESS_RECOURSE_DETAIL: null,

    UPDATE_BUSINESS_CASHBACK_DETAIL: null,
    UPDATED_BUSINESS_CASHBACK_DETAIL: null,
    FAILED_UPDATE_BUSINESS_CASHBACK_DETAIL: null,

    UPDATE_BUSINESS_AGREEMENT_DETAIL: null,
    UPDATED_BUSINESS_AGREEMENT_DETAIL: null,
    FAILED_UPDATE_BUSINESS_AGREEMENT_DETAIL: null,

    UPDATE_BUSINESS_ATTACHMENT_DETAIL: null,
    UPDATED_BUSINESS_ATTACHMENT_DETAIL: null,
    FAILED_UPDATE_BUSINESS_ATTACHMENT_DETAIL: null
});

export const DOCUMENTS_NEW_ACTIONS = keyMirror({
    FETCH_NEW_DOCUMENTS_LIST: null,
    FETCHED_NEW_DOCUMENTS_LIST: null,
    FAILED_FETCH_NEW_DOCUMENTS_LIST: null,

    FETCH_NEW_DOCUMENTS_CATEGORY_LIST: null,
    FETCHED_NEW_DOCUMENTS_CATEGORY_LIST: null,
    FAILED_FETCH_NEW_DOCUMENTS_CATEGORY_LIST: null,

    FETCH_NEW_DOCUMENTS_CHECKLIST: null,
    FETCHED_NEW_DOCUMENTS_CHECKLIST: null,
    FAILED_FETCH_NEW_DOCUMENTS_CHECKLIST: null,

    FETCH_SINGLE_CHECKLIST: null,
    FETCHED_SINGLE_CHECKLIST: null,
    FAILED_FETCH_SINGLE_CHECKLIST: null,

    UPDATE_NEW_DOCUMENTS_CHECKLIST: null,
    UPDATED_NEW_DOCUMENTS_CHECKLIST: null,
    FAILED_UPDATE_NEW_DOCUMENTS_CHECKLIST: null,

    CREATE_NEW_DOCUMENTS_CHECKLIST: null,
    CREATED_NEW_DOCUMENTS_CHECKLIST: null,
    FAILED_CREATE_NEW_DOCUMENTS_CHECKLIST: null
});

export const BUSINESS_PROGRAM_STAGES = keyMirror({
    BUSINESS_PROGRAM: null,
    BASIC_DETAIL: null,
    FACILITY_DETAILS: null,
    QUALIFICATION_DETAILS: null,
    INTEREST_DETAILS: null,
    FEE_DETAILS: null,
    RECOUSE_DETAILS: null,
    CASHBACK_DETAILS: null,
    ATTACHMENT_DETAILS: null,
    AGREEMENT_DETAILS: null
});

export const TOGGLE_HELP = keyMirror({
    TOGGLE_HELP_INFO: null
});
export const MARKET_DATA_ACTIONS = new keyMirror({
    FETCH_MARKET_DATA: null,
    FETCHED_MARKET_DATA: null,
    FAILED_FETCH_MARKET_DATA: null,

    CREATE_MARKET_DATA: null,
    CREATED_MARKET_DATA: null,
    FAILED_CREATE_MARKET_DATA: null,

    UPDATE_MARKET_DATA: null,
    UPDATED_MARKET_DATA: null,
    UPDATE_FAILED_MARKET_DATA: null
});

export const REGION_DISTRIBUTOR_ACTIONS = new keyMirror({
    FETCH_REGION_DATA: null,
    FETCHED_REGION_DATA: null,
    FAILED_FETCH_REGION_DATA: null,

    CREATE_REGION: null,
    CREATED_REGION: null,
    FAILED_CREATE_REGION: null,

    FETCH_REGION_WISE_DATA: null,
    FETCHED_REGION_WISE_DATA: null,
    FAILED_FETCH_REGION_WISE_DATA: null
});


export const ACCOUNT_FACILITY_ACTIONS = new keyMirror({
    CREATE_FACILITY_ACCOUNT: null,
    CREATED_FACILITY_ACCOUNT: null,
    FAILED_CREATE_FACILITY_ACCOUNT: null,
    FETCH_FACILITY_ACCOUNT: null,
    FETCHED_FACILITY_ACCOUNT: null,
    FAILED_FETCH_FACILITY_ACCOUNT: null,
    FETCH_SUPPLY_CHAINS_LIST: null,
    FETCHED_SUPPLY_CHAINS_LIST: null,
    FAILED_FETCH_SUPPLY_CHAINS_LIST: null,
    UPDATE_SUPPLY_CHAINS_LIST: null,
    UPDATED_SUPPLY_CHAINS_LIST: null,
    FAILED_UPDATE_SUPPLY_CHAINS_LIST: null
});

export const DOCUMENT_REVIEW_ACTIONS = new keyMirror({
    FETCH_DOCUMENT_TYPES: null,
    FETCHED_DOCUMENT_TYPES: null,
    FAILED_FETCH_DOCUMENT_TYPES: null,
    FETCH_APPLICANTS_LIST: null,
    FETCHED_APPLICANT_LIST: null,
    FAILED_FETCH_APPLICANT_LIST: null,
    PARSE_DATA: null,
    PARSED_DATA: null,
    FAILED_PARSE_DATA: null,
    REQUEST_DOCUMENTS: null,
    REQUESTED_DOCUMENTS: null,
    FAILED_REQUEST_DOCUMENTS: null,
    SEND_NOTIFICATION: null,
    SENT_NOTIFICATION: null,
    FAILED_SEND_NOTIFICATION: null,
    ADD_REQUEST_REMARKS: null,
    ADDED_REQUEST_REMARKS: null,
    FAILED_ADD_REQUEST_REMARKS: null,
});

export const BANK_STATEMENT_ANALYSER_ACTIONS = new keyMirror({

    FETCH_ANALYSER_JOBS: null,
    FETCHED_ANALYSER_JOBS: null,
    FAILED_FETCH_ANALYSER_JOBS: null,

    CREATE_ANALYSER_REQUEST: null,
    CREATED_ANALYSER_REQUEST: null,
    FAILED_CREATE_ANALYSER_REQUEST: null,
    CREATE_ANALYSER_REQUEST_PERFIOS: null,

    FETCH_REQUEST_DETAILS: null,
    FETCHED_REQUEST_DETAILS: null,
    FAILED_FETCH_REQUEST_DETAILS: null,
    FETCH_REQUEST_DETAILS_PERFIOS: null,

    RETRY_ANALYSIS: null,
    RETRY_ANALYSIS_SUCCESS: null,
    RETRY_ANALYSIS_FAILED: null,
    RETRY_ANALYSIS_PERFIOS: null,

    FETCH_STATEMENT_ANALYSIS: null,
    FETCHED_STATEMENT_ANALYSIS: null,
    FAILED_FETCH_STATEMENT_ANALYSIS: null,
    FETCH_STATEMENT_ANALYSIS_PERFIOS: null

});

export const APPLICANT_VERIFICATION_ACTIONS = new keyMirror({
    FETCH_ASSOCIATES_VERIFICATION_LIST: null,
    FETCHED_ASSOCIATES_VERIFICATION_LIST: null,
    FAILED_FETCH_ASSOCIATES_VERIFICATION_LIST: null,
});

export const CIBIL_ACTIONS = keyMirror({
    FETCH_CIBIL_DETAILS: null,
    FETCHED_CIBIL_DETAILS: null,
    FAILED_FETCH_CIBIL_DETAILS: null,
    UPDATE_CIBIL_DETAILS: null,
    UPDATED_CIBIL_DETAILS: null,
    FAILED_UPDATE_CIBIL_DETAILS: null,
    CIBIL_REQUEST: null,
    CIBIL_REQUESTED: null,
    FAILED_CIBIL_REQUEST: null,
});

export const PAYMENT_PROGRAM_ACTIONS = keyMirror({
    FETCH_PAYMENT_PROGRAM_DETAILS: null,
    FETCHED_PAYMENT_PROGRAM_DETAILS: null,
    FAILED_FETCH_PAYMENT_PROGRAM_DETAILS: null,

    UPDATE_USER_DOCUMENT_DETAILS : null,
    UPDATED_USER_DOCUMENT_DETAILS : null,
    FAILED_UPDATE_USER_DOCUMENT_DETAILS : null,

    FETCH_UPDATE_CHECKLIST_JSON : null,
    FETCH_UPDATED_CHECKLIST_JSON : null,
    FAILED_FETCH_UPDATE_CHECKLIST_JSON : null,

    FETCH_UPDATE_ENTITY_DOCUMENTS : null,
    FETCHED_UPDATE_ENTITY_DOCUMENTS : null,
    FAILED_UPDATE_ENTITY_DOCUMENTS : null,

    FETCH_PAYMENT_PROGRAM_ACTION_DETAILS : null,
    FETCHED_PAYMENT_PROGRAM_ACTION_DETAILS : null,
    FAILED_FETCH_PAYMENT_PROGRAM_ACTION_DETAILS : null,

});

export const DB_ONBOARDING_ACTIONS = keyMirror({
    FETCH_DB_ONBOARDING_LIST: null,
    FETCHED_DB_ONBOARDING_LIST: null,
    FAILED_FETCH_DB_ONBOARDING_LIST : null,

    FETCH_DB_ONBOARDING_VALIDATE_DOCUMENT: null,
    FETCHED_DB_ONBOARDING_VALIDATE_DOCUMENT: null,
    FAILED_FETCH_DB_ONBOARDING_VALIDATE_DOCUMENT : null,

})

export const ONBOARDING_ACTIONS = keyMirror({
    FETCH_CASES_LIST: null,
    FETCHED_CASES_LIST: null,
    FAILED_FETCH_CASES_LIST : null,

    CLEAR_WORKFLOW_CASE_DETAIL: null,
    FETCH_WORKFLOW_CASE_DETAIL: null,
    FETCHED_WORKFLOW_CASE_DETAIL: null,
    FAILED_FETCH_CASE_DETAIL : null,

    FETCH_CASE_PENDENCY_DETAIL: null,
    FETCHED_CASE_PENDENCY_DETAIL: null,
    FAILED_FETCH_CASE_PENDENCY_DETAIL : null,
   
    FETCH_COMPANY_BACKGROUND: null,
    FETCHED_COMPANY_BACKGROUND: null,
    FAILED_FETCH_COMPANY_BACKGROUND : null,
    
    FETCH_DEVIATION_MATRIX: null,
    FETCHED_DEVIATION_MATRIX: null,
    FAILED_FETCH_DEVIATION_MATRIX : null,


})